import { Component, HostListener, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderOverlay } from './components/shared/loader-overlay/loader-overlay';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderOverlay],
  template: `
    <router-outlet></router-outlet>
    <app-loader-overlay message="Loading..."></app-loader-overlay>
  `,
})
export class App implements OnInit {
  private readonly themeStorageKey = 'edge_theme_mode';
  private altDToggleConsumed = false;

  ngOnInit(): void {
    const savedTheme = localStorage.getItem(this.themeStorageKey);
    if (savedTheme === 'dark') {
      this.applyTheme(true);
    }
  }

  // Toggle theme only on Alt+D, once per key press.
  @HostListener('window:keydown', ['$event'])
  onGlobalKeydown(event: KeyboardEvent): void {
    const key = (event.key || '').toLowerCase();
    const isKeyD = event.code === 'KeyD' || key === 'd';
    if (!isKeyD) {
      return;
    }

    const isAltD = event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;

    if (isAltD && !this.altDToggleConsumed) {
      event.preventDefault();
      event.stopPropagation();
      this.altDToggleConsumed = true;
      this.toggleTheme();
    }
  }

  @HostListener('window:keyup', ['$event'])
  onGlobalKeyup(event: KeyboardEvent): void {
    const key = (event.key || '').toLowerCase();
    const isAltOrDKey = key === 'alt' || key === 'd' || event.code === 'KeyD';
    if (isAltOrDKey) {
      this.altDToggleConsumed = false;
    }
  }

  private toggleTheme(): void {
    const root = document.documentElement;
    const isDark = !root.classList.contains('dark');
    this.applyTheme(isDark);
    localStorage.setItem(this.themeStorageKey, isDark ? 'dark' : 'light');
  }

  private applyTheme(isDark: boolean): void {
    const root = document.documentElement;
    const body = document.body;
    root.classList.toggle('dark', isDark);
    body.classList.toggle('dark', isDark);
  }
}